import React from 'react';
import styled from 'styled-components';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import { useLanguage } from '../i18n/LanguageContext';

const PageContainer = styled.main`
  padding: 100px 20px 60px;
  max-width: 1080px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 48px;
  margin-bottom: 18px;
  color: #202020;
`;

const IntroText = styled.p`
  font-size: 18px;
  color: #555;
  line-height: 1.7;
  margin-bottom: 40px;
`;

const TwoColumn = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
`;

const HighlightCard = styled.div`
  padding: 28px;
  border-radius: 10px;
  background: #f7f7f7;
  border: 1px solid #ececec;
`;

const HighlightTitle = styled.h3`
  font-size: 22px;
  margin-bottom: 15px;
  color: #222;
`;

const HighlightText = styled.p`
  margin: 0;
  color: #555;
  line-height: 1.6;
`;

const Timeline = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 70px;
  border-left: 3px solid var(--primary);
`;

const TimelineItem = styled.li`
  position: relative;
  margin-left: 25px;
  padding-left: 25px;
  margin-bottom: 30px;
`;

const TimelineBadge = styled.span`
  position: absolute;
  left: -37px;
  top: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary);
`;

const TimelineYear = styled.h4`
  margin: 0 0 8px;
  font-size: 20px;
  color: #222;
`;

const TimelineText = styled.p`
  margin: 0;
  color: #555;
  line-height: 1.6;
`;

const AboutPage = () => {
  const { t } = useLanguage();
  const milestones = t('pages.about.milestones');

  return (
    <>
      <PageContainer>
        <PageTitle>{t('pages.about.title')}</PageTitle>
        <IntroText>{t('pages.about.intro')}</IntroText>
        <TwoColumn>
          <HighlightCard>
            <HighlightTitle>{t('pages.about.missionTitle')}</HighlightTitle>
            <HighlightText>{t('pages.about.missionText')}</HighlightText>
          </HighlightCard>
          <HighlightCard>
            <HighlightTitle>{t('pages.about.valuesTitle')}</HighlightTitle>
            <HighlightText>{t('pages.about.valuesText')}</HighlightText>
          </HighlightCard>
        </TwoColumn>
        <Timeline>
          {milestones.map((milestone) => (
            <TimelineItem key={milestone.year}>
              <TimelineBadge />
              <TimelineYear>{milestone.year}</TimelineYear>
              <TimelineText>{milestone.text}</TimelineText>
            </TimelineItem>
          ))}
        </Timeline>
      </PageContainer>
      <CTASection />
      <Footer />
    </>
  );
};

export default AboutPage;
